module.exports = __webpack_public_path__ + "img/gou.869ee832.png";